var req = require("!!/app/node_modules/pug-loader/index.js??ref--13-1!/app/src/linagora.esn.sync/app/sidebar/sidebar-menu-item.pug");
module.exports = (req['default'] || req).apply(req, [])